import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useJackpotStore = defineStore('jackpot', () => {
  // State
  const tick = ref(6000)
  const jackpotList = ref([])
  const jackpotEnable = ref(false)
  const loading = ref(false)
  const error = ref(null)

  // Getters
  const getTick = computed(() => tick.value)
  const getJackpotList = computed(() => jackpotList.value)
  const getJackpotEnable = computed(() => jackpotEnable.value)
  const getLoading = computed(() => loading.value)
  const getError = computed(() => error.value)

  // Actions
  function setTick(data) {
    tick.value = data
  }

  function setJackpotList(data) {
    jackpotList.value = data
  }

  function setJackpotEnable(data) {
    jackpotEnable.value = data
  }

  function setLoading(data) {
    loading.value = data
  }

  function setError(data) {
    error.value = data
  }

  return {
    // State
    tick,
    jackpotList,
    jackpotEnable,
    loading,
    error,

    // Getters
    getTick,
    getJackpotList,
    getJackpotEnable,
    getLoading,
    getError,

    // Actions
    setTick,
    setJackpotList,
    setJackpotEnable,
    setLoading,
    setError,
  }
})
